// List of errors to be ignored by Sentry
export const ignoredErrors = [
    "Non-Error promise rejection captured",
    "WKWebView API client did not respond to this postMessage"
];
